import type { NuxtApp } from '#app';

export default defineNuxtPlugin({
  name: 'init',
  dependsOn: ['pinia', 'api', 'app-bridge'],
  parallel: true,
  async setup(_nuxtApp) {
    const nuxtApp = _nuxtApp as NuxtApp;

    const userStore = useUserStore(nuxtApp.$pinia);

    if (import.meta.server) {
      useCookieBruteForcePrevent();

      const mainStore = useMainStore(nuxtApp.$pinia);
      const cartStore = useCartStore(nuxtApp.$pinia);

      // Mostly reads cookies and updates stores
      await userStore.init(nuxtApp);
      cartStore.init();

      // Separate from init to prevent redundant calls, as init may call itself recursively
      await mainStore.initConfiguration(nuxtApp);
      await mainStore.init(nuxtApp);
    } else {
      window.$nuxt = nuxtApp;
      window.auroraQueue = window.auroraQueue || [];

      // Pinia automatically hydrates store values from SSR to CSR, which we use to skip most of the init logic
      // during CSR. We still need to manually update our ancient API wrappers, as they are not yet reactive.
      // For reference, during SSR this happens inside `userStore.init()`.
      nuxtApp.$api.setAccessToken(userStore.token?.access_token);
    }
  },
});
